export default __webpack_public_path__ + "static/media/business.25f1a3b8.svg";